import { HtmlUpdateWidgetController } from '../WidgetController';
export class ReviewWidgetController extends HtmlUpdateWidgetController {
    activeIndex = 0;
    slidesCount = 0;
    itemWidth = 0;

    dom = {
        container: null,
        slides: null,
        leftArrow: null,
        rightArrow: null,
        slidesCarousel: null,
    };
    htmlHash = -1;

    protected install() {
        this.updateState();
        this.autoUpdate();
    }

    protected updateHtml(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ): void {}

    protected beforeUpdate() {
        this.unbindUI();
    }

    protected afterUpdate(
        beforeUpdateData: any,
        html: any,
        successResponse: any
    ) {
        const htmlHash = this.hashCode(html);
        if (this.htmlHash == -1) this.htmlHash = htmlHash;
        if (this.htmlHash !== htmlHash) {
            this.htmlHash = htmlHash;
            super.afterUpdate(beforeUpdateData, html, successResponse);
        }
        this.updateState();
    }

    private hashCode(str) {
        let hash = 0;
        if (str.length == 0) return hash;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    private updateState() {
        this.dom.container = $(this.getElement());

        this.dom.leftArrow = this.dom.container.find(
            '[js-node="widget-arrow-left"]'
        );
        this.dom.rightArrow = this.dom.container.find(
            '[js-node="widget-arrow-right"]'
        );
        this.dom.slidesCarousel = this.dom.container.find(
            '[js-node="widget-banners-items-wrapper"]'
        );

        this.bindUI(true);
    }

    private pushMtmEvent(type: string) {
        document.dispatchEvent(
            new CustomEvent('mtmCustomEvent', {
                detail: {
                    id: 'd-i02-e9',
                    container: this.dom.container[0],
                    trigger: type,
                    index: this.activeIndex + 1,
                    slides: this.dom.slidesCarousel.children().length,
                },
            })
        );
    }

    //left btn
    private moveRightClick(evt) {
        const self = evt.data;
        self.nextSlideTriggerTime =
            new Date().getTime() + self.SLIDER_CLICK_SUSPEND_TIME;
        const item = self.dom.slidesCarousel.children().eq(-1);

        item.prependTo(self.dom.slidesCarousel);
        self.dom.slidesCarousel.css({ left: -self.itemWidth });
        self.dom.leftArrow.off('click', self.moveRightClick);
        self.dom.slidesCarousel.animate({ left: 0 }, 500, function () {
            self.dom.leftArrow.on('click', self, self.moveRightClick);
        });

        if (self.activeIndex <= 0) {
            self.activeIndex = self.dom.slidesCarousel.children().length - 1;
        } else {
            self.activeIndex--;
        }
        self.pushMtmEvent('arrow-left');
    }

    //right btn
    private moveLeftClick(evt) {
        const self = evt.data;
        self.nextSlideTriggerTime =
            new Date().getTime() + self.SLIDER_CLICK_SUSPEND_TIME;
        self.moveLeft(self);
        self.pushMtmEvent('arrow-right');
    }

    private moveLeft(self) {
        const item = self.dom.slidesCarousel.children().eq(0);

        self.dom.rightArrow.off('click', self.moveLeftClick);
        self.dom.slidesCarousel.animate(
            { left: -self.itemWidth },
            500,
            function () {
                item.appendTo(self.dom.slidesCarousel);
                self.dom.slidesCarousel.css({ left: 0 });
                self.dom.rightArrow.on('click', self, self.moveLeftClick);
            }
        );

        if (self.activeIndex + 1 >= self.dom.slidesCarousel.children().length) {
            self.activeIndex = 0;
        } else {
            self.activeIndex++;
        }
    }

    private ElementTextHeight() {
        const slideElementCoef = $('.widget-review__coefs-wrapper');

        for (let i = 0; i < slideElementCoef.length; i++) {
            const elementHeight = $(slideElementCoef[i]).height();

            if (elementHeight == 0) {
                const elemText = $('.widget-review__description');
                $(elemText[i]).css('-webkit-line-clamp', '7');
            }
        }
    }

    private slideTimer(self) {
        self.moveLeft(self);
    }

    isInitialized = false;
    slideTimerId: any = null;
    nextSlideTriggerTime: any = 0;
    SLIDER_TIMER_FREQUENCY = 500;
    SLIDER_TIMER_INTERVAL = 6000;
    SLIDER_CLICK_SUSPEND_TIME = 12000;

    private bindUI(updating: boolean) {
        if (!this.isInitialized || updating) {
            this.isInitialized = true;

            const self = this;

            self.itemWidth = self.dom.slidesCarousel.children().outerWidth();

            self.ElementTextHeight();

            if ($('.widget-review__item').length > 1) {
                self.dom.leftArrow.on('click', this, this.moveRightClick);

                self.dom.rightArrow.on('click', this, this.moveLeftClick);

                self.slideTimerId = setInterval(function () {
                    if (self.nextSlideTriggerTime < new Date().getTime()) {
                        self.nextSlideTriggerTime =
                            new Date().getTime() + self.SLIDER_TIMER_INTERVAL;
                        self.slideTimer(self);

                        self.nextSlideTriggerTime =
                            new Date().getTime() + self.SLIDER_TIMER_INTERVAL;
                    }
                }, self.SLIDER_TIMER_FREQUENCY);
            }
        }
    }

    private unbindUI() {
        this.dom.rightArrow.off('click');
        this.dom.leftArrow.off('click');
        if (this.slideTimerId) {
            clearInterval(this.slideTimerId);
        }
    }
}
